import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { WebConfigDashService } from '../../../../shared/services/webConfigDash.service';
import { WebListaAtasService } from 'app/main/content/shared/services/webListaAtas.service';


@Component({
  selector: 'app-delete.dialog',
  templateUrl: '../../dialogs/delete/delete.dialog.html',
  styleUrls: ['../../dialogs/delete/delete.dialog.scss']
})
export class DeleteDialogAtasComponent {

  constructor(public dialogRef: MatDialogRef<DeleteDialogAtasComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public webListaAtasService: WebListaAtasService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmDelete(): void {
    this.webListaAtasService.listDeleteData(this.data.idConfig);
  }
}